import { Dispatch } from "redux";
import {
  ERROR_LOADING_TYPES,
  GET_ALL_TYPES,
  RESET_DATA,
  START_LOADING_TYPES,
  STOP_LOADING_TYPES,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchTypesAction =
  () => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_TYPES });
    try {
      const currentState = getState();
      const queryString = generateQueryStringForUsers(
        currentState.Filters.typesFilter
      );

      const { data } =
        await apiLibrary.SpeciesAndObjects.getAllTypes(queryString);
      dispatch({
        type: GET_ALL_TYPES,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_TYPES });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_TYPES });
      // dispatch(loadingState(false))
    }
  };
